import React from 'react';
import styles from './index.module.scss';

const Terminal = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26'>
            <path
                d='M22.923,0H3.077A3.081,3.081,0,0,0,0,3.077v1.98H26V3.077A3.081,3.081,0,0,0,22.923,0Z'
                transform='translate(0 0)'
                className={styles.light}
            />
            <path
                d='M0,145.943a3.081,3.081,0,0,0,3.077,3.077H22.923A3.081,3.081,0,0,0,26,145.943V129.6H0Z'
                transform='translate(0 -123.021)'
                className={styles.light}
            />
            <path
                d='M56.937,368.224h-5.3a.762.762,0,0,1,0-1.523h5.3a.762.762,0,1,1,0,1.523Z'
                transform='translate(-48.288 -348.079)'
                className={styles.dark}
            />
            <path
                d='M304.273,370.782a.675.675,0,0,1-.954.954l-1.636-1.636a1.108,1.108,0,0,1,0-1.565l1.637-1.636a.674.674,0,1,1,.954.954l-1.465,1.465Z'
                transform='translate(-286.056 -348.08)'
                className={styles.dark}
            />
            <path
                d='M392.023,370.1l-1.636,1.636a.675.675,0,1,1-.954-.954l1.465-1.465-1.465-1.465a.675.675,0,1,1,.954-.954l1.636,1.636a1.106,1.106,0,0,1,0,1.565Z'
                transform='translate(-369.469 -348.08)'
                className={styles.dark}
            />
            <path
                d='M67.026,247.569a.708.708,0,0,1-.637.762H51.508a.774.774,0,0,1,0-1.523H66.389A.708.708,0,0,1,67.026,247.569Z'
                transform='translate(-48.288 -234.274)'
                className={styles.dark}
            />
            <path
                d='M51.633,186.807H68.694a.762.762,0,0,1,0,1.523H51.633a.762.762,0,0,1,0-1.523Z'
                transform='translate(-48.288 -177.321)'
                className={styles.dark}
            />
            <path
                d='M51.427,306.7H62.712c.307,0,.556.341.556.762s-.249.762-.556.762H51.427c-.307,0-.556-.341-.556-.762S51.12,306.7,51.427,306.7Z'
                transform='translate(-48.288 -291.126)'
                className={styles.dark}
            />
            <path
                d='M52.41,36.324h-.777a.762.762,0,0,1,0-1.523h.777a.762.762,0,0,1,0,1.523Z'
                transform='translate(-48.288 -33.034)'
                className={styles.dark}
            />
            <path
                d='M107.9,36.324h-.777a.762.762,0,0,1,0-1.523h.777a.762.762,0,1,1,0,1.523Z'
                transform='translate(-100.958 -33.034)'
                className={styles.dark}
            />
            <path
                d='M163.25,36.324h-.777a.762.762,0,0,1,0-1.523h.777a.762.762,0,0,1,0,1.523Z'
                transform='translate(-153.499 -33.034)'
                className={styles.dark}
            />
        </svg>
    );
};

export default Terminal;
